import {Component, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {LanguageModel} from '../../models/language.model';
import {PublicationModel, PublicationPageAbleModel} from '../../models/publication.model';
import {Router} from '@angular/router';
import {UserModel} from '../../models/user.model';
import {ConfirmationService} from 'primeng/api';
import {I18nService} from '../../../shared/i18n';
import {Observable} from 'rxjs/Observable';
import * as moment from 'moment';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {PublicationService} from '../../services/publication.service';
import {PublicationQueryModel} from '../../models/query.model';
import {NotificationService} from '../../../shared/utils/notification.service';
import * as FileSaver from 'file-saver';
import {AppCommunicationService} from '../../services/app-communication.service';
import {DataTable} from 'primeng/primeng';

@Component({
    selector: 'app-publication-list-view',
    templateUrl: './publication-list-view.component.html',
    styleUrls: ['./publication-list-view.component.scss']
})
export class PublicationListViewComponent implements OnInit {
    loading = true;
    pTable = {
        colNumber: 6,
        expandedRows: {}
    };

    filterButtons = [
                {
            text: 'New',
            count: 0,
            active: false,
            color:'bg-color-magenta'
        },
        {
            text: 'Wait for prints',
            count: 0,
            active: false,
            color:'bg-color-pinkDark'
        },
        {
            text: 'Reminder',
            count: 0,
            active: false,
            color:'bg-color-orange'
        },
        {

            text: 'All',
            count: 0,
            active: true,
            color:'bg-color-blueLight'
        }
    ]

    yearFilter = {
        data: [],
        settings: {
            singleSelection: false,
            idField: 'item_id',
            textField: 'item_text',
            selectAllText: 'Označiť všetko',
            unSelectAllText: 'Odznačiť všetko',
            itemsShowLimit: 2,
            allowSearchFilter: false
        }
    };
    filter = {
        search: '',
        year: [],
        state: 0,
        page:1,
        pageSize:15,
        totalItems: 1
    };
    isCertificationDownloading=false;
    publications: PublicationModel[] = [];

    @ViewChild('dt') dataTable: DataTable;
    constructor(private router: Router,
                private confirmationService: ConfirmationService,
                private i18nService: I18nService,
                private publicationService:PublicationService,
                private notificationService: NotificationService,
                private _appCommunicationService: AppCommunicationService ) {
        this.generateYearsFilter();
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        let timeout = null;
        const textInput = <HTMLInputElement>document.getElementById('search');
        textInput.onkeyup = () => {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                this.filter.search = textInput.value;
                if(this.filter.search.length === 0 || this.filter.search.length > 2) {
                    this.filterData();
                }

            }, 500)
        }
    }

    editPublication(id: number) {
        this.router.navigate(['/publication/' + id]);
    }


    setPage(pageInfo) {
        this.filter.page = (pageInfo.first + pageInfo.rows) / 15;
        this.filterData(false);
    }


    onPrintDeliveryClick(rowData) {
        this.notificationService.smartMessageBox({
            title: this.i18nService.getTranslation('confirmation'),
            content: this.i18nService.getTranslation('confirmPrintsDelivery'),
            buttons: '['+this.i18nService.getTranslation('No')+']['+
            this.i18nService.getTranslation('Yes')+']'
        }, (ButtonPressed) => {
            if (ButtonPressed === this.i18nService.getTranslation('Yes') ) {
                setTimeout(() => {
                    this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Loading data'));
                });
                this.publicationService.acceptPrints(rowData.id).subscribe(() => {
                    this._appCommunicationService.loadingOff();
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('saved'),
                        color: '#659265',
                        content: this.i18nService.getTranslation('printsHasBeenAccepted'),
                        timeout: 8000
                    });
                    rowData.isPrintDelivered=true;
                    rowData.state=3;
                    this.filterButtons[2].count=this.publications.filter(p=>p.state===2).length;
                },err=> {
                    console.error(err);
                    this._appCommunicationService.loadingOff();
                    this.notificationService.smallBox({
                        title: this.i18nService.getTranslation('error'),
                        color: '#923837',
                        iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                        content: this.i18nService.getTranslation('somethingIsWrongError'),
                        timeout: 10000
                    });
                })

            }
        });

    }
    onDownloadCertClick(rowData) {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
       this.isCertificationDownloading=true;
       this.publicationService.downloadPrintCertification(rowData.id).subscribe(
           (data:Blob)=> {
               FileSaver.saveAs(data, 'certificate.pdf');
               this.isCertificationDownloading=false;
               this._appCommunicationService.loadingOff()
           },err=> {
               console.error(err);
               this._appCommunicationService.loadingOff();
               this.isCertificationDownloading=false;
               this.notificationService.smallBox({
                   title: this.i18nService.getTranslation('error'),
                   color: '#923837',
                   iconSmall: 'fa fa-warning fa-2x fadeInRight animated',
                   content: this.i18nService.getTranslation('somethingIsWrongError'),
                   timeout: 10000
               });
           });
    }

    filterData(resetPagination = true) {
        if (resetPagination)  {
            this.filter.page=1;
            this.dataTable.first=0;
        }
        this.getPublications();
    }



    onSelectAllYears(value) {
        this.filter.year.push(...value);
        this.getPublications();

    }

    onDeselectAllYears() {
        this.filter.year = [];
        this.getPublications();
    }

    clearSearchInput() {
        this.filter.search = '';
        this.filterData();
    }

    generateYearsFilter() {
        let initYear = Number.parseInt(moment(Date.now()).format('YYYY'));
        const endYear = 2010;

        while (initYear >= endYear) {
            this.yearFilter.data.push({
                item_id: initYear,
                item_text: initYear.toString()
            });
            if (initYear === Number.parseInt(moment(Date.now()).format('YYYY'))) {
                this.filter.year.push({
                    item_id: initYear,
                    item_text: initYear.toString()
                });
            }
            initYear--;
        }
    }

    onFilterButtonClick(index: number) {
        this.filter.state=index+1;
        if(this.filter.state===4) {this.filter.state=0;}
        this.filterButtons.forEach(btn => btn.active = false);
        this.filterButtons[index].active = true;
        this.filterData();
    }
    getPublications() {
        this.loading=true;

        const publicationquery = new PublicationQueryModel();
        publicationquery.years =  this.filter.year.map(year => year.item_id );

        // state === 3 filter waitng for prints, but  remainder was sent
        if (this.filter.state === 3 ) {
            publicationquery.isReminderSent=true;
            publicationquery.stateId=2;
        } else {
            publicationquery.stateId=this.filter.state;
            publicationquery.isReminderSent=false;
        }
        publicationquery.page= this.filter.page;
        publicationquery.pageSize= this.filter.pageSize;
        publicationquery.searchText=this.filter.search;

        this.publicationService.getPublications(publicationquery).subscribe((data:PublicationPageAbleModel)=> {
            this.publications=data.items;
            this.loading = false;
            this.filter.totalItems=data.totalItems;
            console.log(data.totalItems)
        }, err=> {
            this.loading = false;
            console.error(err)
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/publication-list-view/publication-list-view.component.ts